// extracted by mini-css-extract-plugin
export default {"manager-info-section":"buhCFsSpQQz0fpj8iUA7","table-title-wrapper":"mazPUEo95N_iEOBcP473","table-title-side-field":"wd2J4kUZB6Z1IHcDiFB4","table-wrapper":"pODmCenXXvRiA8n_gk0J"};